import { combineReducers } from 'redux';
import { firebaseReducer } from 'react-redux-firebase';
import { firestoreReducer } from 'redux-firestore';
import facilitatorSessionReducer from './facilitatorSessionReducer';
import notifierReducer from './notifierReducer';
import staffingReducer from './staffingReducer';

const reducers = combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  facilitatorSession: facilitatorSessionReducer,
  notifications: notifierReducer,
  staffing: staffingReducer,
});

export default reducers;
